var _path, _path2, _path3, _path4, _path5, _path6, _circle, _circle2, _path7, _path8, _path9, _path0, _ellipse, _ellipse2, _ellipse3, _path1, _path10;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgEyeLevel = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 300,
    height: 300,
    viewBox: "0 0 300 300",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M164.468 157.653H237.742",
    stroke: "#DA5CEE",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeDasharray: "6.28 6.28"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M250.565 139.968C250.565 135.169 255.698 132.117 259.914 134.408L268.241 138.934C270.953 140.408 272.641 143.246 272.641 146.333V194.458C272.641 199.339 267.349 202.382 263.131 199.927L253.71 194.445C251.763 193.312 250.565 191.229 250.565 188.976V139.968Z",
    stroke: "#424243",
    strokeWidth: 2
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M253.752 140.803C253.752 138.688 256.051 137.375 257.872 138.45L266.016 143.252C266.849 143.744 267.36 144.639 267.36 145.606V193.002C267.36 195.115 265.064 196.428 263.243 195.356L255.099 190.564C254.264 190.073 253.752 189.177 253.752 188.209V140.803Z",
    fill: "#DA5CEE"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M98.8301 146.159C105.028 143.175 110.72 142.037 116.382 142.351C129.419 143.074 137.411 155.992 139.623 168.86L142.428 185.182C142.62 186.295 141.763 187.312 140.633 187.312H128.458",
    stroke: "#424243",
    strokeWidth: 2,
    strokeLinecap: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M99.3911 158.175C98.9084 158.443 98.7345 159.052 99.0028 159.535C99.271 160.017 99.8799 160.191 100.363 159.923L99.3911 158.175ZM100.363 159.923C106.549 156.485 113.297 156.319 118.994 157.776L119.49 155.838C113.407 154.283 106.115 154.439 99.3911 158.175L100.363 159.923Z",
    fill: "#424243"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M136.397 155.195C135.848 155.26 135.456 155.757 135.521 156.305C135.586 156.854 136.083 157.246 136.631 157.181L136.397 155.195ZM136.631 157.181C142.647 156.471 146.572 157.188 149.639 158.878L150.605 157.126C147.055 155.171 142.672 154.454 136.397 155.195L136.631 157.181Z",
    fill: "#424243"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 117.792,
    cy: 160.102,
    r: 4.55345,
    fill: "#424243"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 145.568,
    cy: 160.156,
    r: 4.55345,
    fill: "#424243"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M118.719 201.966C127.441 204.997 131.642 204.508 138.607 201.966",
    stroke: "#424243",
    strokeWidth: 2,
    strokeLinecap: "round"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M69.0704 180.055C70.7155 204.731 94.2295 217.352 120.238 222.919C125.41 224.026 130.716 221.904 133.937 217.71C144.026 204.569 146.582 198.594 149.211 166.85C152.854 122.868 129.631 99.9017 105.498 99.9017C81.3647 99.9016 61.1246 123.061 59.957 153.19",
    stroke: "#424243",
    strokeWidth: 2
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M69.9813 159.564C81.3647 159.564 103.221 145.449 113.239 133.154C128.721 141.806 145.113 148.181 149.667 149.091L150.587 149.275C151.268 149.411 151.889 148.847 151.828 148.156C149.895 126.063 143.451 111.535 130.237 102.699C113.82 91.7201 91.3817 92.9739 74.5772 103.35C53.1141 116.602 37.8851 141.17 57.2314 172.769C52.8989 164.573 57.1482 148.108 65.8831 154.555L69.9813 159.564Z",
    fill: "#424243",
    stroke: "#424243",
    strokeWidth: 2
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    d: "M67.249 156.272C65.5604 154.429 62.1788 153.929 59.4356 155.469C58.629 155.921 58.0727 156.703 57.747 157.569C54.2328 166.912 57.828 177.944 61.8777 180.256C64.0324 181.485 68.267 180.871 69.7035 180.256",
    stroke: "#424243",
    strokeWidth: 2
  })), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 61.585,
    cy: 102.372,
    rx: 19.1245,
    ry: 15.1413,
    transform: "rotate(-35 61.585 102.372)",
    fill: "#424243"
  })), _ellipse2 || (_ellipse2 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 47.3703,
    cy: 120.656,
    rx: 13.794,
    ry: 12.3277,
    transform: "rotate(-35 47.3703 120.656)",
    fill: "#424243"
  })), _ellipse3 || (_ellipse3 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 50.5197,
    cy: 142.391,
    rx: 9.98171,
    ry: 13.7366,
    transform: "rotate(-35 50.5197 142.391)",
    fill: "#424243"
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    d: "M66.1478 106.436C65.7262 106.793 65.6736 107.424 66.0303 107.846C66.3871 108.267 67.0181 108.32 67.4397 107.963L66.1478 106.436ZM67.4397 107.963C70.4285 105.434 72.1326 103.913 74.0686 102.55C75.9834 101.202 78.1353 100.006 81.9843 98.1944L81.1327 96.3848C77.2407 98.2163 74.9699 99.4701 72.9175 100.915C70.8861 102.344 69.0784 103.956 66.1478 106.436L67.4397 107.963Z",
    fill: "white"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M53.5887 176.867C54.9547 180.055 61.0834 189.666 70.8918 190.072C69.7676 186.168 69.6106 185.211 69.0704 180.404C66.3122 181.113 64.7158 181.699 61.7849 180.965C57.5356 176.103 56.2959 172.925 56.3207 166.394L48.5799 148.636C48.5799 163.207 51.8493 172.809 53.5887 176.867Z",
    fill: "#424243",
    stroke: "#424243",
    strokeWidth: 2
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgEyeLevel);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/eye_level.233215274dc957b454dd1525710ba86e.svg";